export default __webpack_public_path__ + "static/media/logout.4b8cee4f.svg";